import React, { useState, useEffect,useRef  } from 'react';
import {Layout} from "@components/layout/Layout";
import Chart from 'chart.js/auto';
import btcIcon from '@assets/images/icons/btc.svg';
import ethIcon from '@assets/images/icons/eth.svg';
import bnbIcon from '@assets/images/icons/bnb.svg';
import xrpIcon from '@assets/images/icons/xrp.svg';
import adaIcon from '@assets/images/icons/ada.svg';
import dogeIcon from '@assets/images/icons/doge.svg';
import solIcon from '@assets/images/icons/sol.svg';
import dotIcon from '@assets/images/icons/dot.svg';
import ltcIcon from '@assets/images/icons/ltc.svg';
import bchIcon from '@assets/images/icons/bch.svg';
import avaxIcon from '@assets/images/icons/avax.svg';
import trxIcon from '@assets/images/icons/trx.svg';
import shibIcon from '@assets/images/icons/shib.svg';
import uniIcon from '@assets/images/icons/uni.svg';
import maticIcon from '@assets/images/icons/matic.svg';
import linkIcon from '@assets/images/icons/link.svg';
import xlmIcon from '@assets/images/icons/xlm.svg';
import atomIcon from '@assets/images/icons/atom.svg';
import nearIcon from '@assets/images/icons/near.svg';
import etcIcon from '@assets/images/icons/etc.svg';
import eosIcon from '@assets/images/icons/eos.svg';
import ftmIcon from '@assets/images/icons/ftm.svg';
import daiIcon from '@assets/images/icons/dai.svg';
import ExpandingLoader from "@components/common/ExpandingLoader";

const cryptoIcons = {
  btc: btcIcon,
  eth: ethIcon,
  bnb: bnbIcon,
  xrp: xrpIcon,
  ada: adaIcon,
  doge: dogeIcon,
  sol: solIcon,
  dot: dotIcon,
  ltc: ltcIcon,
  bch: bchIcon,
  avax: avaxIcon,
  trx: trxIcon,
  shib: shibIcon,
  uni: uniIcon,
  matic: maticIcon,
  link: linkIcon,
  xlm: xlmIcon,
  atom: atomIcon,
  near: nearIcon,
  etc: etcIcon,
  eos: eosIcon,
  ftm: ftmIcon,
  dai: daiIcon,
};

const cryptoPairs = [
  { symbol: 'BTCUSDT', name: 'Bitcoin', priceId: 'btc-price', changeId: 'btc-change', chartId: 'btc-chart' },
  { symbol: 'ETHUSDT', name: 'Ethereum', priceId: 'eth-price', changeId: 'eth-change', chartId: 'eth-chart' },
  { symbol: 'BNBUSDT', name: 'Binance Coin', priceId: 'bnb-price', changeId: 'bnb-change', chartId: 'bnb-chart' },
  { symbol: 'XRPUSDT', name: 'Ripple', priceId: 'xrp-price', changeId: 'xrp-change', chartId: 'xrp-chart' },
  { symbol: 'ADAUSDT', name: 'Cardano', priceId: 'ada-price', changeId: 'ada-change', chartId: 'ada-chart' },
  { symbol: 'DOGEUSDT', name: 'Dogecoin', priceId: 'doge-price', changeId: 'doge-change', chartId: 'doge-chart' },
  { symbol: 'SOLUSDT', name: 'Solana', priceId: 'sol-price', changeId: 'sol-change', chartId: 'sol-chart' },
  { symbol: 'LTCUSDT', name: 'Litecoin', priceId: 'ltc-price', changeId: 'ltc-change', chartId: 'ltc-chart' },
];
const forexPairs = [
  { symbol: 'EURUSD', name: 'EUR / USD', priceId: 'eurusd-price', changeId: 'eurusd-change', chartId: 'eurusd-chart' },
  { symbol: 'USDJPY', name: 'USD / JPY', priceId: 'usdjpy-price', changeId: 'usdjpy-change', chartId: 'usdjpy-chart' },
  { symbol: 'GBPUSD', name: 'GBP / USD', priceId: 'gbpusd-price', changeId: 'gbpusd-change', chartId: 'gbpusd-chart' },
  { symbol: 'USDCHF', name: 'USD / CHF', priceId: 'usdchf-price', changeId: 'usdchf-change', chartId: 'usdchf-chart' },
  { symbol: 'AUDUSD', name: 'AUD / USD', priceId: 'audusd-price', changeId: 'audusd-change', chartId: 'audusd-chart' },
  { symbol: 'NZDUSD', name: 'NZD / USD', priceId: 'nzdusd-price', changeId: 'nzdusd-change', chartId: 'nzdusd-chart' },
  { symbol: 'USDCAD', name: 'USD / CAD', priceId: 'usdcad-price', changeId: 'usdcad-change', chartId: 'usdcad-chart' },
  { symbol: 'USDSGD', name: 'USD / SGD', priceId: 'usdsgd-price', changeId: 'usdsgd-change', chartId: 'usdsgd-chart' },
  { symbol: 'USDMXN', name: 'USD / MXN', priceId: 'usdmxn-price', changeId: 'usdmxn-change', chartId: 'usdmxn-chart' },
  { symbol: 'USDZAR', name: 'USD / ZAR', priceId: 'usdzar-price', changeId: 'usdzar-change', chartId: 'usdzar-chart' },
  { symbol: 'USDINR', name: 'USD / INR', priceId: 'usdinr-price', changeId: 'usdinr-change', chartId: 'usdinr-chart' },
  { symbol: 'USDBRL', name: 'USD / BRL', priceId: 'usdbrl-price', changeId: 'usdbrl-change', chartId: 'usdbrl-chart' },
];

const forexIcons = {
  eurusd: require('@assets/images/main/eurusd.png'),
  usdjpy: require('@assets/images/main/usdjpy.png'),
  gbpusd: require('@assets/images/main/gbpusd.png'),
  usdchf: require('@assets/images/main/usdchf.png'),
  audusd: require('@assets/images/main/audusd.png'),
  nzdusd: require('@assets/images/main/nzdusd.png'),
  usdcad: require('@assets/images/main/usdcad.png'),
  usdsgd: require('@assets/images/main/usdsgd.png'),
  usdmxn: require('@assets/images/main/usdmxn.png'),
  usdzar: require('@assets/images/main/usdzar.png'),
  usdinr: require('@assets/images/main/usdinr.png'),
  usdbrl: require('@assets/images/main/usdbrl.png'),
};

export const Tools = () => {
 // work with api 
 const [activeTab, setActiveTab] = useState('forex');
 const chartsRef = useRef({});
 const [forexData, setForexData] = useState({});
 const [currentPeriod, setCurrentPeriod] = useState('1D');
 const inputRef = useRef(null);
 const containerRef = useRef(null);
 const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//  const [forexLoading, setForexLoading] = useState({});
 const [forexGlobalLoading, setForexGlobalLoading] = useState(true);

 const fetchCryptoFromBinance = async (pair) => {
  const binanceIntervalMap = {
    '1D': { interval: '30m', limit: 48 },
    '1W': { interval: '4h', limit: 42 },
    '1M': { interval: '1d', limit: 30 },
    '1Y': { interval: '1w', limit: 52 }
  };

  const { interval, limit } = binanceIntervalMap[currentPeriod] || { interval: '30m', limit: 48 };
  const url = `https://api.binance.com/api/v3/klines?symbol=${pair.symbol}&interval=${interval}&limit=${limit}`;

  try {
    const res = await fetch(url);
    const data = await res.json();
    const prices = data.map(kline => parseFloat(kline[4]));
    const timestamps = data.map(kline =>
      new Date(kline[0]).toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: 'short'
      })
    );

    const latestPrice = prices[prices.length - 1];
    const oldestPrice = prices[0];
    const change = (((latestPrice - oldestPrice) / oldestPrice) * 100).toFixed(2);

    // --- update price
    const priceEl = document.getElementById(pair.priceId);
    if (priceEl) {
      priceEl.innerHTML = `${latestPrice.toFixed(6)} <span class="${change < 0 ? 'negative' : 'positive'}">${change}%</span>`;
    }

    // --- update change
    const changeEl = document.getElementById(pair.changeId);
    if (changeEl) {
      changeEl.className = `change ${change < 0 ? 'negative' : 'positive'}`;
      changeEl.innerHTML = `${change}% <small>TW change</small>`;
    }

    // --- Wait until canvas exists
    requestAnimationFrame(() => {
      const canvas = document.getElementById(pair.chartId);
      if (!canvas) {
        setTimeout(() => drawChart(), 100);
      } else {
        drawChart();
      }
    });

    const drawChart = () => {
      const canvas = document.getElementById(pair.chartId);
      const ctx = canvas?.getContext('2d');
      if (!ctx) return;

      //  Destroy old chart from ref
      const oldChart = chartsRef.current[pair.chartId];
      if (oldChart && typeof oldChart.destroy === 'function') {
        oldChart.destroy();
        delete chartsRef.current[pair.chartId];
      }

      //  Create new chart
      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: timestamps,
          datasets: [{
            data,
            borderColor: '#0f0',
            backgroundColor: 'transparent',
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          scales: {
            x: { display: false },
            y: { display: false }
          },
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          }
        }
      });

      //  Save to ref + state
      chartsRef.current[pair.chartId] = chart;
    };
  } catch (error) {
    console.error(`Error fetching data for ${pair.symbol}:`, error);
  }
};

const fetchForexFromBackend = async (pair) => {
  // Увімкнути лоадер
  // setForexLoading(prev => ({ ...prev, [pair.symbol]: true }));

  try {
    const res = await fetch(`/api/forex/ohlc/${pair.symbol}/${currentPeriod}`);
    const data = await res.json();

    if (!Array.isArray(data) || data.length === 0) {
      console.warn(`No OHLC data for ${pair.symbol}:`, data);
      return;
    }

    const prices = data.map(d => d.rate);
    const labels = data.map(d => d.date);

    const latestPrice = prices[prices.length - 1];
    const oldestPrice = prices[0];
    const change = (((latestPrice - oldestPrice) / oldestPrice) * 100).toFixed(2);

    // Зберігаємо дані в state
    setForexData(prev => ({
      ...prev,
      [pair.symbol]: {
        price: latestPrice,
        change: parseFloat(change),
      }
    }));

    // DOM буде готовий до оновлення графіку
    const tryUpdateChart = () => {
      const canvas = document.getElementById(pair.chartId);
      if (canvas) {
        updateChart(pair, labels, prices);
      } else {
        requestAnimationFrame(tryUpdateChart);
      }
    };
    
    tryUpdateChart();
  } catch (err) {
    console.error(`OHLC fetch error for ${pair.symbol}`, err);
  } finally {
    // Вимкнути лоадер
    // setForexLoading(prev => ({ ...prev, [pair.symbol]: false }));
  }
};







const updateChart = (pair, labels, data) => {
  const canvas = document.getElementById(pair.chartId);
  const ctx = canvas?.getContext('2d');
  if (!ctx) return;

  const oldChart = chartsRef.current[pair.chartId];
  if (oldChart && typeof oldChart.destroy === 'function') {
    oldChart.destroy();
    delete chartsRef.current[pair.chartId];
  }

  const chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets: [
        {
          data,
          borderColor: '#0f0',
          backgroundColor: 'transparent',
          tension: 0.4,
          borderWidth: 2,
          pointRadius: 0,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      scales: {
        x: { display: false },
        y: { display: false },
      },
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      },
    },
  });

  chartsRef.current[pair.chartId] = chart;
};

 const [sortDirection, setSortDirection] = useState('asc');

const handleSortClick = () => {
  const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  setSortDirection(newDirection);

  const container = document.querySelector('.tools-box');
  if (!container) return;

  const pairs = activeTab === 'crypto' ? cryptoPairs : forexPairs;

  const sorted = [...pairs]
    .filter(pair => pair.name.toLowerCase().includes(searchQuery))
    .sort((a, b) => {
      const aText = pairText(a);
      const bText = pairText(b);
      return newDirection === 'asc'
        ? aText.localeCompare(bText)
        : bText.localeCompare(aText);
    });

  sorted.forEach(pair => {
    const card = document.getElementById(pair.priceId)?.closest('.tool-card');
    if (card) container.appendChild(card);
  });

  function pairText(pair) {
    return pair.name?.toLowerCase() || pair.symbol.toLowerCase();
  }
};
const [showSearch, setShowSearch] = useState(false);
const [searchQuery, setSearchQuery] = useState('');

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target)
    ) {
      setShowSearch(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);
useEffect(() => {
  if (showSearch && inputRef.current) {
    inputRef.current.focus();
  }
}, [showSearch]);
useEffect(() => {
  if (activeTab === 'crypto') {
    const visiblePairs = cryptoPairs.filter(pair =>
      pair.name.toLowerCase().includes(searchQuery)
    );
    visiblePairs.forEach(fetchCryptoFromBinance);
  }
}, [currentPeriod, searchQuery, activeTab]);

useEffect(() => {
  const fetchForexInBatches = async () => {
    const visiblePairs = forexPairs.filter(pair =>
      pair.name.toLowerCase().includes(searchQuery)
    );

    const batchSize = 8;
    for (let i = 0; i < visiblePairs.length; i += batchSize) {
      const batch = visiblePairs.slice(i, i + batchSize);
      await Promise.all(batch.map(fetchForexFromBackend));
      if (i + batchSize < visiblePairs.length) await delay(1000);
    }

    setForexGlobalLoading(false); // <- Коли все завантажилось
  };

  if (activeTab === 'forex') {
    setForexGlobalLoading(true); // <- Починаємо з true
    fetchForexInBatches();
  }
}, [currentPeriod, searchQuery, activeTab]);


  return (<Layout>
    <div className="basic-main">
      <div className="container">
        <div className="tools-header"><img src={require("@assets/images/main/tools-header-img.jpg")} alt="img"/>
          <h1>Сrypto аssets</h1>
          <h3>Track live prices, weekly changes, and detailed performance metrics — all in one place. Compare, analyze,
            and stay ahead of the market.</h3>
        </div>
        <div style={{display: 'block', overflowX: 'unset'}} className="section tabs">
          <div className="tools-actions">
          <ul className="tools-tabs-menu">
            <li className="tab-icon">
              <img src={require("@assets/images/main/cronika-icon-yellow.svg").default} alt="icon"/>
            </li>
            <li
              className={activeTab === 'forex' ? 'active' : ''}
              onClick={() => setActiveTab('forex')}
            >
              Forex
            </li>
            <li
              className={activeTab === 'crypto' ? 'active' : ''}
              onClick={() => setActiveTab('crypto')}
            >
              Crypto
            </li>
          </ul>
            <div className="right-col">
            <select onChange={(e) => setCurrentPeriod(e.target.value)}>
              <option value="1D">1D change</option>
              <option value="1W">1W change</option>
              <option value="1M">1M change</option>
              <option value="1Y">1Y change</option>
            </select>
               <button className="sort-btn" type="button" onClick={handleSortClick}>
                <svg className="active" width="8" height="13" viewBox="0 0 8 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd"
                        d="M4.57915 0.76635V10.5397L6.49915 8.53968C6.56204 8.47319 6.63783 8.42022 6.72189 8.38402C6.80595 8.34781 6.89651 8.32914 6.98804 8.32914C7.07956 8.32914 7.17013 8.34781 7.25419 8.38402C7.33825 8.42022 7.41404 8.47319 7.47693 8.53968C7.60714 8.67748 7.67969 8.85988 7.67969 9.04946C7.67969 9.23905 7.60714 9.42144 7.47693 9.55924L4.37737 12.7895C4.31449 12.856 4.23869 12.9089 4.15463 12.9451C4.07057 12.9813 3.98001 13 3.88848 13C3.79696 13 3.7064 12.9813 3.62234 12.9451C3.53827 12.9089 3.46248 12.856 3.39959 12.7895L0.298262 9.55924C0.167484 9.42199 0.0948625 9.23948 0.0955954 9.04991C0.0946326 8.86002 0.167271 8.67715 0.298262 8.53968C0.36116 8.47305 0.437006 8.41996 0.52115 8.38367C0.605294 8.34739 0.695961 8.32867 0.787595 8.32867C0.879228 8.32867 0.969897 8.34739 1.05404 8.38367C1.13818 8.41996 1.21403 8.47305 1.27693 8.53968L3.19693 10.5397V0.76635C3.19693 0.368128 3.50626 0.0454597 3.88848 0.0454597C4.27071 0.0454597 4.58004 0.368127 4.58004 0.76546L4.57915 0.76635Z"
                        fill="white"/>
                </svg>
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd"
                        d="M4.57915 0.76635V10.5397L6.49915 8.53968C6.56204 8.47319 6.63783 8.42022 6.72189 8.38402C6.80595 8.34781 6.89651 8.32914 6.98804 8.32914C7.07956 8.32914 7.17013 8.34781 7.25419 8.38402C7.33825 8.42022 7.41404 8.47319 7.47693 8.53968C7.60714 8.67748 7.67969 8.85988 7.67969 9.04946C7.67969 9.23905 7.60714 9.42144 7.47693 9.55924L4.37737 12.7895C4.31449 12.856 4.23869 12.9089 4.15463 12.9451C4.07057 12.9813 3.98001 13 3.88848 13C3.79696 13 3.7064 12.9813 3.62234 12.9451C3.53827 12.9089 3.46248 12.856 3.39959 12.7895L0.298262 9.55924C0.167484 9.42199 0.0948625 9.23948 0.0955954 9.04991C0.0946326 8.86002 0.167271 8.67715 0.298262 8.53968C0.36116 8.47305 0.437006 8.41996 0.52115 8.38367C0.605294 8.34739 0.695961 8.32867 0.787595 8.32867C0.879228 8.32867 0.969897 8.34739 1.05404 8.38367C1.13818 8.41996 1.21403 8.47305 1.27693 8.53968L3.19693 10.5397V0.76635C3.19693 0.368128 3.50626 0.0454597 3.88848 0.0454597C4.27071 0.0454597 4.58004 0.368127 4.58004 0.76546L4.57915 0.76635Z"
                        fill="white"/>
                </svg>
              </button>
              <div
                    ref={containerRef}
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}
                  >
                    <button
                      className="search-btn"
                      type="button"
                      onClick={() => setShowSearch(prev => !prev)}
                    ></button>
                    {showSearch && (
                      <input
                        ref={inputRef}
                        type="text"
                        placeholder="Search crypto..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                        style={{
                          padding: '8px 14px',
                          borderRadius: '12px',
                          backgroundColor: '#1a1a1a', 
                          color: '#fff',               
                          border: '1px solid #2a2a2a', 
                          outline: 'none',
                          fontSize: '14px',
                          width: '200px',
                          transition: 'all 0.2s ease',
                        }}
                      />
                    )}
                  </div>
            </div>
          </div>
          {activeTab === 'forex' && (
  <div className="tab" id="forex">
    <h3>23 Forex Pairs</h3>
    <div className="tools-box">
    {forexPairs
  .filter(pair => pair.name.toLowerCase().includes(searchQuery))
  .sort((a, b) => {
    const aText = a.name.toLowerCase();
    const bText = b.name.toLowerCase();
    return sortDirection === 'asc' ? aText.localeCompare(bText) : bText.localeCompare(aText);
  })
  .map(pair => (
    <div key={pair.symbol} className="tool-card">
      <figure className="tool-logo">
        <img
          src={forexIcons[pair.symbol.toLowerCase()]}
          alt={`${pair.symbol} icon`}
        />
      </figure>
      <strong className="tool-title">
        {pair.symbol.slice(0, 3) + '/' + pair.symbol.slice(3)}
      </strong>

      {forexGlobalLoading ? (
        <div style={{ height: 60 }}>
          <ExpandingLoader />
        </div>
      ) : (
        <>
          <strong className="price">
            {forexData[pair.symbol]?.price?.toFixed(6)}{' '}
            <span className={forexData[pair.symbol]?.change < 0 ? 'negative' : 'positive'}>
              {forexData[pair.symbol]?.change}%
            </span>
          </strong>

          <div className="tool-chart">
            <figure className="chart">
              <canvas id={pair.chartId}></canvas>
            </figure>

            <strong
              className={`change ${forexData[pair.symbol]?.change < 0 ? 'negative' : 'positive'}`}
            >
              {forexData[pair.symbol]?.change}% <small>TW change</small>
            </strong>
          </div>
        </>
      )}

      <a
        className="basic-button tool-btn"
        href="https://app.cronika.com/auth/signup"
      >
        Trade
      </a>
    </div>
))}
    </div>
  </div>
)}

{activeTab === 'crypto' && (
  <div className="tab" id="crypto">
    <h3>23 Cryptocurrencies (CFD)</h3>
    <div className="tools-box">
      {cryptoPairs
        .filter(pair => pair.name.toLowerCase().includes(searchQuery))
        .map(pair => (
          <div key={pair.symbol} className="tool-card">
            <figure className="tool-logo">
              <img
                src={cryptoIcons[pair.symbol.toLowerCase().replace('usdt', '')]}
                alt={`${pair.name} logo`}
              />
            </figure>
            <strong className="tool-title">{pair.name}</strong>
            <strong className="price" id={pair.priceId}></strong>
            <div className="tool-chart">
              <figure className="chart">
                <canvas id={pair.chartId}></canvas>
              </figure>
              <strong className="change" id={pair.changeId}></strong>
            </div>
            <a
              className="basic-button tool-btn"
              href="https://app.cronika.com/auth/signup"
            >
              Trade
            </a>
          </div>
        ))}
    </div>
  </div>
)}


        </div>
      </div>
    </div>
  </Layout>);
};

export default Tools;
